module.exports = __webpack_public_path__ + "static/img/logo__google.6cbbc1a2.svg";